import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Injectable, PLATFORM_ID, computed, inject, signal } from '@angular/core';

export type AppTheme = 'light' | 'dark';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private readonly document = inject(DOCUMENT);
  private readonly platformId = inject(PLATFORM_ID);
  private readonly storageKey = 'mh_re_dsm_theme';
  private readonly currentTheme = signal<AppTheme>('light');

  readonly theme = this.currentTheme.asReadonly();
  readonly isDarkMode = computed(() => this.currentTheme() === 'dark');

  constructor() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    const savedTheme = localStorage.getItem(this.storageKey);
    this.setTheme(savedTheme === 'dark' ? 'dark' : 'light', false);
  }

  toggleTheme(): void {
    this.setTheme(this.isDarkMode() ? 'light' : 'dark');
  }

  setTheme(theme: AppTheme, persist = true): void {
    this.currentTheme.set(theme);
    this.document.documentElement.dataset['theme'] = theme;

    if (persist && isPlatformBrowser(this.platformId)) {
      localStorage.setItem(this.storageKey, theme);
    }
  }
}
